// import { MaterialsSidebar } from '../shared-components/MaterialsSidebar';
import { ProjectHub } from '@platform/client';
import { SimplifiedUserRole, TeamProjectHubResponse } from '@platform/client/schemas';
import { HubPage } from '../HubPage';
import { TeamProgressAccordions } from './TeamProgressAccordions';
import { useParams } from 'wouter';
import { ProjectDetailsSection } from '../shared-components/ProjectDetailsSection';
import { SideBar } from '../shared-components/SideBar';
import { ROUTES } from '../../routes/consts';
import ErrorPage from '../../../ErrorPage';
import Skeleton from 'react-loading-skeleton';

const TeamProjectTrackerPage = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const {
    data: hubData,
    isSuccess,
    isLoading,
    isError,
  } = ProjectHub.useGetTeamProjectHubData({
    project_id: parseInt(projectId),
  });
  return (
    <>
      {isError && <ErrorPage />}
      {isLoading && (
        <HubPage
          projectDetails={<Skeleton height={200} />}
          progressAccordions={<Skeleton height={400} />}
          sideBarContent={<Skeleton height={400} />}
        />
      )}
      {isSuccess && (
        <HubPage
          projectDetails={
            <ProjectDetailsSection
              status={hubData.status}
              project={hubData.project}
              organization={hubData.organization}
            />
          }
          progressAccordions={<TeamProgressAccordions hubData={hubData} />}
          sideBarContent={<TeamSideBarContent hubData={hubData} />}
        />
      )}
    </>
  );
};

const TeamSideBarContent = ({ hubData }: { hubData: TeamProjectHubResponse }) => {
  return (
    <>
      {hubData.userType === SimplifiedUserRole.PROFESSIONAL && (
        <SideBar
          title='Representative'
          items={[
            {
              type: 'contact',
              firstname: hubData.representative.firstname,
              lastname: hubData.representative.lastname,
              email: hubData.representative.email,
              avatarUrl: hubData.representative.avatar ?? undefined,
            },
          ]}
        />
      )}
      <SideBar
        title='Your Team'
        items={hubData.professionals.map((pro) => {
          return {
            type: 'contact',
            firstname: pro.firstname,
            lastname: pro.lastname,
            email: pro.email,
            avatarUrl: pro.avatar ?? undefined,
            profileUrl: `${ROUTES.DIRECTORY}/professionals/${pro.id}`,
          };
        })}
      />
    </>
  );
};

export default TeamProjectTrackerPage;
